$(document).ready(function() {
  if ($('#add-organization-service-form').length > 0 && $('.amount-div').length > 0){
    checkAmount('.amount', '.amount-div');
    checkAmount('.rate-amount', '.rate-amount-div');
  }
});
